import axios from 'axios'
import { registerHttpClients } from '@vnetwork/datacentral-core/http'
import datacentral from './datacentral'
import servicemgmt from './servicemgmt'
import warehouse from './warehouse'
import livechat from './livechat'

// Core domain services (`@vnetwork/datacentral-core/domain`) call the API
// through this same instance, so they share the auth SDK interceptors.
// Register a client here once something outside the app needs it: core needs
// `datacentral`; @vnetwork/datacentral-warehouse also calls `warehouse` and
// `servicemgmt` through getHttpClient (#59); the Livechat package calls
// `livechat` (#216). The others stay in lazy route
// chunks.
// `datacentralPublic`: plain axios, NO interceptors, for the public token pages
// (employee-confirmation); core 0.9.1 `domain/regulations` uses it.
registerHttpClients({
    datacentral,
    servicemgmt,
    warehouse,
    livechat,
    datacentralPublic: axios.create({ baseURL: import.meta.env.APP_API_URL }),
})
